export default {
  templates: [],
  template: {},
};
